function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref =
/*#__PURE__*/
React.createElement("path", {
  d: "M5.76.5h24.48a5.26 5.26 0 015.26 5.26v24.48a5.26 5.26 0 01-5.26 5.26H5.76A5.26 5.26 0 01.5 30.24V5.76A5.26 5.26 0 015.76.5z",
  fill: "url(#FreeTools_svg__paint0_linear_643_2048)",
  stroke: "url(#FreeTools_svg__paint1_linear_643_2048)"
});

var _ref2 =
/*#__PURE__*/
React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M26.733 17.925l-1.728 1.695a.54.54 0 01-.754 0l-.717-.703a.497.497 0 01-.13-.44c.033-.456-.162-.9-.523-1.189-.556-.545-1.14-.677-1.419-.404l-.603.592a.72.72 0 01-1.006 0L17.841 15.5a.69.69 0 010-.987l1.062-1.042a.336.336 0 00-.002-.479c-1.372-1.379-2.973-.962-4.175-.257a.364.364 0 01-.411-.055l-.155-.152a.262.262 0 01.004-.376l.002-.001c1.724-1.692 5.378-2.022 7.012-.419l2.525 2.478c.112.118.16.281.13.44-.033.456.162.9.524 1.189.294.354.746.546 1.211.514a.519.519 0 01.448.127l.717.703a.517.517 0 010 .74zm-9.017-1.495l1.198 1.176a.526.526 0 01.008.745l-7.076 7.26a1.468 1.468 0 01-2.07.023l-.24-.236a1.403 1.403 0 01.023-2.032l7.397-6.944a.55.55 0 01.76.008z",
  fill: "url(#FreeTools_svg__paint2_linear_643_2048)"
});

var _ref3 =
/*#__PURE__*/
React.createElement("defs", null, React.createElement("linearGradient", {
  id: "FreeTools_svg__paint0_linear_643_2048",
  x1: 54,
  y1: 18,
  x2: 18,
  y2: -18,
  gradientUnits: "userSpaceOnUse"
}, React.createElement("stop", {
  stopColor: "#E1E9F0"
}), React.createElement("stop", {
  offset: 1,
  stopColor: "#FAFBFC"
})), React.createElement("linearGradient", {
  id: "FreeTools_svg__paint1_linear_643_2048",
  x1: 54,
  y1: 18,
  x2: 18,
  y2: -18,
  gradientUnits: "userSpaceOnUse"
}, React.createElement("stop", {
  stopColor: "#9BADBC",
  stopOpacity: 0.202
}), React.createElement("stop", {
  offset: 1,
  stopColor: "#E1E9F0"
})), React.createElement("linearGradient", {
  id: "FreeTools_svg__paint2_linear_643_2048",
  x1: 0.222,
  y1: 18.37,
  x2: 15.418,
  y2: 35.96,
  gradientUnits: "userSpaceOnUse"
}, React.createElement("stop", {
  stopColor: "#9BADBC"
}), React.createElement("stop", {
  offset: 1,
  stopColor: "#596168"
})));

var SvgFreeTools = function SvgFreeTools(props) {
  return React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none"
  }, props), _ref, _ref2, _ref3);
};

export default SvgFreeTools;